$(function() {
	$(document).on('click', '#filter_mobile_button', function(e) {
		e.stopPropagation();
		$('#event_category_nav nav').toggleClass('open');
	})

	$(document).click(function(){
		if($('#event_category_nav nav').hasClass('open')){
			$('#event_category_nav nav').toggleClass('open');
		}
	})
});